import React from 'react';
import cls from 'classnames';
import styled from 'styled-components';
import { theme } from '@/lib';

import { ItemOptions, ItemProps } from '../types';

const Checkbox = (props: ItemProps & { options: ItemOptions }) => {
  const {
    className,
    label,
    name,
    options,
    disabled,
    value = [],
    onChange,
  } = props;

  const handleChange = (item) => {
    if (disabled) {
      return;
    }

    const index = value.indexOf(item.value);
    let newValue = [];
    if (index === -1) {
      newValue = value.concat([item.value]);
    } else {
      newValue = value.filter((item) => item.value !== item.value);
    }
    onChange(name, newValue);
  };

  return (
    <Wrap
      className={cls('form-item form-item-checkbox', className, {
        disabled,
      })}
    >
      {label && <label className="form-item-label">{label}</label>}
      <div className="form-item-input">
        {options.map((item) => {
          return (
            <label
              key={item.value}
              className={cls('item', {
                active: value.includes(item.value),
                disabled: item.disabled,
              })}
              onClick={() => handleChange(item)}
            >
              <i className="item-icon" />
              <span className="item-text">{item.label}</span>
            </label>
          );
        })}
      </div>
    </Wrap>
  );
};

const Wrap = styled.div`
  &.disabled {
    .item {
      cursor: not-allowed;
    }
  }

  .item {
    cursor: pointer;
    margin-right: 8px;
    &-icon {
      display: inline-block;
      vertical-align: middle;
      border: solid 1px #cccccc;
      width: 12px;
      height: 12px;
      border-radius: 50%;
      position: relative;
      margin-right: 6px;
    }

    &-text {
      display: inline-block;
      vertical-align: middle;
    }
  }

  .active .item-icon:after {
    position: absolute;
    content: '';
    left: 1px;
    top: 1px;
    height: 10px;
    width: 10px;
    border-radius: 50%;
    background-color: ${theme.clientColor.third};
  }
`;

export default Checkbox;
